export const KNOCK_FEED_CHANNEL_ID = import.meta.env.VITE_APP_KNOCK_FEED_CHANNEL_ID as string;

export type NotificationCategory = 'all' | 'orders' | 'team' | 'api';

export type NotificationChannel = 'email' | 'in_app_feed';

export type NotificationConfigExtended = {
  knockId: string;
  title: string;
  description: string;
  tooltip?: string;
  channels: NotificationChannel[];
  type: 'category' | 'workflow';
};

export type NotificationCategoryExtended = {
  id: string;
  title: string;
  notifications: NotificationConfigExtended[];
};

export type ChannelPreferences = Record<NotificationChannel, boolean>;
export type LocalPreferences = Record<string, ChannelPreferences>;

export const NOTIFICATION_CATEGORIES: NotificationCategoryExtended[] = [
  {
    id: 'orders',
    title: 'Orders',
    notifications: [
      {
        knockId: 'order_updates',
        title: 'Order updates',
        description:
          'Get notified when an order you created or were added to completes, expires, or gets updated in any other way.',
        channels: ['email', 'in_app_feed'],
        type: 'category',
      },
      {
        knockId: 'aso_orders',
        title: 'Automatically created orders',
        description: 'Get notified when an order is created via ASO.',
        channels: ['email', 'in_app_feed'],
        type: 'category',
      },
      {
        knockId: 'refresh_reconnection',
        title: 'Refreshes requiring reconnection',
        description: 'Get notified when a refreshed order requires the end-user to reconnect their accounts.',
        channels: ['email', 'in_app_feed'],
        type: 'category',
      },
    ],
  },
  {
    id: 'team',
    title: 'Team',
    notifications: [
      {
        knockId: 'members_pending_approval',
        title: 'Members pending approval',
        description: 'Get notified when someone tries to join your company as a collaborator on Truv.',
        channels: ['email', 'in_app_feed'],
        type: 'category',
      },
    ],
  },
  {
    id: 'api',
    title: 'API',
    notifications: [
      {
        knockId: 'api_prod_keys',
        title: 'Production keys',
        description: 'Get notified when a production API key is created, updated, or deleted.',
        channels: ['email', 'in_app_feed'],
        type: 'category',
      },
    ],
  },
];
